import { render, staticRenderFns } from "./zhitui.vue?vue&type=template&id=39f6b0c2&scoped=true"
import script from "./zhitui.vue?vue&type=script&lang=js"
export * from "./zhitui.vue?vue&type=script&lang=js"
import style0 from "./zhitui.vue?vue&type=style&index=0&id=39f6b0c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6b0c2",
  null
  
)

export default component.exports